
<template>  
  <div class="header">
    <div class="header-hint">{{ $t("Misc.headerHint") }}</div>
    <v-app-bar :clipped-left="clipped" app fixed class="main-header">
      <img
        class="menu"
        :src="require(`@/assets/${menuIcon}.png`)"
        @click="showSearchMenu()"
      />
      <!--  <div >
        <v-btn text @click.stop="showSearchMenu()" class="userMenu"
          v-bind:class="{ 'clicked': searchMenuDrawer }" 
          :style="this.$store.getters.GET_showSearchMenu.style">
          <v-icon class="header-button-icon">fas fa-sliders-h</v-icon>
        </v-btn>      
      </div> -->

      <img
        v-if="!isMobile || (isMobile && !menuVisible)"
        class="logo"
        src="@/assets/fercam_logo.png"
        @click="navigateTo('/')"
      />

      <div class="actions">
        <div
          class="d-flex align-center flex-row language-div"
          v-if="!isMobile || (isMobile && menuVisible)"
        >
          <div
            v-for="(item, index) in supportedLanguages"
            :key="index"
            @click="changeLanguage(item.code, true)"
          >
            <div :class="setLanguageClass(item.code, index)">
              <span>{{ item.code.toUpperCase() }}</span>
            </div>
          </div>
        </div>
        <img
          v-if="!isMobile || (isMobile && !menuVisible)"
          class="default profile"
          src="@/assets/account_circle.png"
          @click="navigateTo('/profile')"
        />
        <communicationsImage
          class="comImg"
          v-if="!isMobile"
          :isHeader="true"
        ></communicationsImage>
        <img
          class="default logout"
          src="@/assets/logout.png"
          @click="logout()"
          v-if="!isMobile"
        />
      </div>
    </v-app-bar>
    <div v-if="showBreadcrumb" class="header-breadcrumb">
      <img class="default logout" src="@/assets/back.png" @click="back()" />
      <span>{{ breadcrumb_title }}</span>
    </div>

    <v-dialog v-model="showCommunication" persistent
      ><communication
        class="communication-detail"
        :title="communicationTitle"
        :description="communicationDescription"
        :isPreview="false"
        :communicationId="communicationId"
        :uploadDate="communicationUploadDate"
      ></communication
    ></v-dialog>
  </div>
</template>
<style>
.menu {
  cursor: pointer;
}
/********* header *********/
.header .img.comImg {
  height: 64px;
  width: 59px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  margin-right: 20px;
  position: relative;
  cursor: pointer;
}
.header .img.comImg #comToReadBorder {
  right: -3px;
  top: -3px;
  height: 25px;
  width: 25px;
}

.header .img.comImg #comToRead {
  font: normal normal bold 20px Roboto;
  height: 25px;
  width: 25px;
  border-radius: 25px;
}

.header .main-header {
  background-color: #6f767a !important;
  top: 40px !important;
}

.language-selected span {
  font: normal normal bold 36px/43px Lato;
  color: #6f767a;
  cursor: pointer;
  background-color: #ffffff;
  margin: 0 22px 0 22px;
  padding: 0 6px 0 6px;
}

.language-not-selected span {
  font: normal normal normal 36px/43px Lato;
  color: #ffffff;
  cursor: pointer;
  background-color: #6f767a;
  margin: 0 28px 0 28px;
}

.language-sep {
  border-left: 2px solid #ffffff;
}

.header .default {
  height: 59px;
  cursor: pointer;
  padding: 0 20px 0 0px;
}

.header .default.logout {
  height: 46px;
}

.header .logo {
  height: 44px;
  cursor: pointer;
}

.v-toolbar {
  -webkit-box-shadow: none !important;
}

.menu-overlay {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: #5d6367;
  opacity: 0;
  display: none;
}

.menu-overlay-enabled {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: #5d6367;
  opacity: 1;
  transition: opacity 0.3s ease-out;
  z-index: 1;
}

.header .actions {
  display: flex;
  position: absolute;
  right: 24px;
  align-items: center;
}

@media (min-width: 600px) {
  .header .v-toolbar__content {
    height: 100px !important;
    /* menu image has 3 pixel of padding */
    padding: 0 36px 0 33px !important;
  }

  .header .menu {
    height: 86px;
    margin-right: 40px;
  }
}

@media (max-width: 600px) {
  .v-toolbar__content {
    padding-left: 16px !important;
  }

  .header .logo {
    height: 37px;
    cursor: pointer;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  .header .default {
    height: 50px;
    cursor: pointer;
    padding: 0 0 0 6px;
  }

  .language-selected span {
    margin: 0 16px 0 28px;
  }

  .language-not-selected span {
    margin: 0 16px 0 28px;
  }

  .header .v-toolbar__content {
    height: 71px !important;
    /* padding: 0 9px 0 16px !important; */
  }

  .header .menu {
    height: 63px;
    margin-right: none;
  }

  .header .default.profile {
    right: 16px;
  }
}
</style>
<script>
import { Trans } from "@/plugins/Translation";
import VueCookies from "vue-cookies";
import MyFercamApi from "../api/MyFercam/MyFercamApi.js";

export default {
  components: {},

  props: {
    clipped: Boolean,
    drawer: Boolean,
    fixed: Boolean,
    items: Array,
    title: String,
    userName: String,
    refresh: Boolean,
  },

  data() {
    return {
      comToRead: 0,
    };
  },

  async beforeCreated() {
    await this.$GAUserAuth.refreshUserInfo().then((res) => {});
  },

  async created() {
    window.addEventListener("resize", this.myEventHandler);
    this.setIsMobile();
    await this.$GAUserAuth.refreshUserInfo().then((res) => {
      var email = this.$GAUserAuth.user.username;
      this.name =
        email.substring(0, 11).split(".")[0].charAt(0).toUpperCase() +
        email.substring(0, 11).split(".")[0].slice(1);

      //   MyFercamApi.GetCommunications(
      //     this.$GAUserAuth.user.companyCode,
      //     this.$GAUserAuth.user.username
      //   ).then((res) => {
      //     this.comToRead = res.data.length;
      //     console.log("comToRead header", this.comToRead);
      //   });
    });

    // console.log("_culture", $cookies.get("_culture"));

    // set the right language at startup
    if (!$cookies.get("_culture")) {
      //   console.log("language not found");
      this.setlanguageInCookie("it");
    }

    Trans.changeLanguage(this.getlanguageFromCookie()).then(() => {
      //this.setMenuItems();
    });

    this.readCommunications();
  },
  mounted() {
    this.drawerData = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  data() {
    return {
      drawerData: this.drawer,
      name: "",
      menuVisible: false,
      menuItems: [],
      menuIcon: "menu_close",
      searchMenuDrawer: {
        show: null,
        style: null,
      },
      isMobile: false,
      breadcrumb_title: "",
      backurl: "",
      showBreadcrumb: false,
      // communication
      showCommunication: false,
      communicationTitle: "",
      communicationDescription: "",
      communications: [],
      communicationId: null,
      communicationUploadDate: "",
    };
  },

  computed: {
    supportedLanguages() {
      return Trans.supportedLanguages;
    },
    currentLanguage() {
      return Trans.currentLanguage;
    },
    menuImageChanged() {
      return this.$store.getters.GET_showSearchMenu;
    },
    setBreadcrumb: function () {
      return this.$store.getters.GET_setBreadcrumb;
    },
    currentRouteName() {
      return this.$route.name;
    },
    communicationsUpdated: function () {
      return this.$store.getters.GET_communicationsUpdated;
    },
  },

  watch: {
    currentRouteName: {
      handler() {
        this.showBreadcrumb =
          this.isMobile && this.$route.name == "communications";
        // console.log("path", this.$route.name);
      },
    },
    menuImageChanged: {
      handler() {
        if (this.$store.getters.GET_showSearchMenu.show) {
          this.menuIcon = "menu_open";
          this.menuVisible = true;
        } else {
          this.menuIcon = "menu_close";
          this.menuVisible = false;
        }
      },
    },
    setBreadcrumb: {
      handler() {
        var breadcrumb = this.$store.getters.GET_setBreadcrumb;
        // console.log("breadcrumb", breadcrumb);
        this.breadcrumb_title = breadcrumb.text;
      },
    },
    communicationsUpdated: {
      handler() {
        // console.log("communications updated header");
        // this.getCommunications(this.$GAUserAuth.user);
        this.showCommunication = false;
        this.readCommunications();
      },
    },
  },

  methods: {
    readCommunications() {
      var user = this.$GAUserAuth.user;
      MyFercamApi.GetMandatoryCommunications(
        user.companyCode,
        user.username
      ).then((res) => {
        this.communications = res.data;
        if (this.communications.length > 0) {
          this.communicationTitle = this.communications[0].titolo;
          this.communicationDescription = this.communications[0].descrizione;
          this.showCommunication = true;
          this.communicationId = this.communications[0].id;
          this.communicationUploadDate = this.communications[0].dataCaricamento;
        }
        // console.log("comms to be read", this.communications);
      });
    },
    myEventHandler(e) {
      this.setIsMobile();
    },
    setIsMobile() {
      this.isMobile = window.innerWidth < this.$genericClass.mobileMaxWidth();
    },
    setLanguageClass(language, index) {
      let languageClass = "";

      if (this.currentLanguage == language) languageClass = "language-selected";
      else languageClass = "language-not-selected";

      if (index == this.supportedLanguages.length - 1)
        languageClass += " language-sep";

      // console.log("languageClass", languageClass);
      return languageClass;
    },
    getlanguageFromCookie() {
      return $cookies.get("_culture").split("-")[0];
    },
    setlanguageInCookie(lang) {
      return $cookies.set("_culture", lang + "-" + lang.toUpperCase());
    },
    isCurrentLanguage(lang) {
      return lang === this.currentLanguage;
    },
    changeLanguage(lang, save) {
      if (save) {
        //localStorage.setItem("Language", lang);
        this.setlanguageInCookie(lang);
      }
      const to = this.$router.resolve({ params: { lang } });
      return Trans.changeLanguage(lang).then(() => {
        //this.setMenuItems();
        // console.log("change language", lang, save, Trans.currentLanguage);
        this.$router.push(to.location);
      });
    },

    setMenuItems() {
      let menuItems = this.getItemsMenu();
      var pathname = location.pathname.split("/");
      pathname.shift();
      pathname.shift();
      var searchRoute = "/" + pathname.join("/");
      //console.log("header created", searchRoute);
      for (let index = 0; index < menuItems.length; index++) {
        var res = this.findParents(menuItems[index], searchRoute);
        if (res) menuItems[index].selected = true;
      }

      this.menuItems = menuItems;
      localStorage.setItem("menu", JSON.stringify(menuItems));
    },

    getItemsMenu() {
      let menuItems = [
        {
          title: Trans.i18n.t("header.Menu1"),
          selected: false,
          route: "",
          child: [
            {
              title: "menu11",
              route: "/Index1",
              selected: false,
            },
            {
              title: "menu12",
              route: "/Index2",
              selected: false,
              child: [
                {
                  title: "menu121",
                  route: "/Index3",
                  selected: false,
                },
              ],
            },
          ],
        },
        {
          title: Trans.i18n.t("header.Menu2"),
          route: "/Index4",
          selected: false,
          child: [
            {
              title: "menu211",
              route: "/Index",
              selected: false,
            },
          ],
        },
      ];
      return menuItems;
    },

    findParents(node, searchForName) {
      //debugger;
      // If current node name matches the search name, return
      // empty array which is the beginning of our parent result
      if (node.route === searchForName) {
        return [];
      }

      // Otherwise, if this node has a tree field/value, recursively
      // process the nodes in this tree array
      if (Array.isArray(node.child)) {
        for (var treeNode of node.child) {
          // Recursively process treeNode. If an array result is
          // returned, then add the treeNode.name to that result
          // and return recursively
          const childResult = this.findParents(treeNode, searchForName);

          if (Array.isArray(childResult)) {
            //console.log("child", treeNode.title);
            treeNode.selected = true;
            return [treeNode.title].concat(childResult);
          }
        }
      }
    },

    showSearchMenu() {
      if (this.$store.getters.GET_showSearchMenu.show) {
        let showSM = {
          show: false,
          style: "color: #cecece",
        };
        this.$store.commit("SET_showSearchMenu", showSM);
        this.menuIcon = "menu_close";
      } else {
        let showSM = {
          show: true,
          style: "color: white",
        };
        this.$store.commit("SET_showSearchMenu", showSM);
        this.menuIcon = "menu_open";
      }
      this.searchMenuDrawer = this.$store.getters.GET_showSearchMenu;

      return this.$store.getters.GET_showSearchMenu;
    },

    isLanguageSelected(lang) {
      //   console.log("language selected", this.getlanguageFromCookie());

      //return $cookies.get("_culture") == lang;
      return this.getlanguageFromCookie() == lang;

      //return localStorage.getItem("Language", lang) == lang;
    },

    navigateTo(a) {
      location.href = "/" + this.currentLanguage + a;
    },
    async login() {
      await this.$GAUserAuth.signin();
    },
    async logout() {
      //   var current_domain = this.$genericClass.GetCurrentDomain(
      //     window.location.hostname
      //   );

      sessionStorage.removeItem("GlobalAuthUser");

      var res = $cookies.remove(
        "GlobalAuthUser",
        null,
        this.$genericClass.GetCurrentDomain()
      );

      var hostName = window.location.hostname;
      var logout_url =
        this.$genericClass.GetSSOUrl() + "/home/logout?r=" + btoa(hostName);
      //   console.log("logout url", logout_url);
      location.href = logout_url;
    },
    back() {
      this.navigateTo(this.backurl);
    },
  },
};
</script>

